import { UserSetAvailabilityStatus } from '@api/generated/graphql';
import appManager from '@app/appManager';
import { serviceState } from './state';
import { getUser } from './requireUser';
import { ServiceUserUtils } from './serviceUserUtils';

export type ServiceUserStatusEvent = {
  status: UserSetAvailabilityStatus;
};

export function notifyUserStatusChanged(status: UserSetAvailabilityStatus) {
  appManager.events.emit<ServiceUserStatusEvent>('user.status.updated', {
    status,
  });
}

function notifyUserStatusForceAway() {
  appManager.events.emit('user.status.force_away');
}

export function setUserStatus({
  userId,
  status,
}: {
  userId: string;
  status?: UserSetAvailabilityStatus;
}) {
  const user = getUser(userId);
  if (!user) {
    return;
  }

  if (status) {
    ServiceUserUtils.setAvailabilityStatus(user, status);
  }
}

/**
 * Kazoo sets the user to unavailable on force away, so all we need to do is set the status locally and notify the app.
 * @param userId
 */
export function setUserUnavailable(userId: string) {
  const user = getUser(userId);
  if (!user) {
    return;
  }

  if (user.id === serviceState.id) {
    notifyUserStatusForceAway();
  }
  ServiceUserUtils.setAvailabilityStatus(
    user,
    UserSetAvailabilityStatus.Unavailable,
  );
}
